import React from "react"
// import './WhatsAppMarketing.css'

// import WhatsAppMarketingBanner from '../../assets/bannerImages/WhatsAppMarketingBanner.webp'
import whatsAppMarketingBanner from '../../assets/bannerImages/WhatsAppMarketingBanner.jpeg'
import monitoringTheDeviation from '../../assets/images/monitoringTheDeviation.webp'
import googleadsLogo from '../../assets/logos/googleadsLogo.jpg'
import metaadsLogo from '../../assets/logos/metaadsLogo.jpg'
import microsoftadsLogo from '../../assets/logos/microsoftadsLogo.jpg'
import linkedinLogo from '../../assets/logos/linkedinLogo.jpg'
import { Link } from "react-router-dom"

import tailoredStrategies from '../../assets/images/tailoredStrategies.jpg'
import robustAnalytics from '../../assets/images/robustAnalytics.jpg'
import seamlessIntegration from '../../assets/images/seamlessIntegration.png'

import precisionTargeting from '../../assets/images/targetedStrategies.jpg'
import captivatingContent from '../../assets/images/creativeContent.jpg'
import measurableOutcomes from '../../assets/images/maximizedROI.jpg'


export default function WhatsAppMarketing(){
    return(
        <div className="whatsAppMarketing">
            <WMR1/>
            <WMR2/>
            <WMR3/>
            <WMR4/>
            <ContactSection/>
            {/* this contact section's css is in social media marketing page's css file */}
        </div>
    )
}

function WMR1(){
    return(
        <div className='wmr1'>
            <img loading="lazy" src={whatsAppMarketingBanner} alt='wm-banner' className='wm-banner-img'/>
            <h1 className='wmr1-head'>WhatsApp Marketing</h1>
            <div className='overlay'></div>
        </div>
    )
}

function WMR2(){
    return(
        <div className='wmr2'>
            <div className='strip'>
                <h1>What Is <span>WhatsApp Marketing</span>?</h1>
                <hr/>   
                <p>WhatsApp Marketing utilizes the messaging platform to engage customers and promote products or services effectively. It employs features like broadcast messages, group chats, and WhatsApp Business API to foster direct communication, personalized experiences, and efficient conversions. By leveraging WhatsApp's reach and immediacy, businesses establish direct channels, nurture relationships, and achieve marketing goals seamlessly.</p>
            </div>
        </div>
    )
}

function WMR3(){
    return(
        <div className='wmr3'>
            <div className='rowThreeContainer'>
                <h1 className='rowThreeHead'>
                Why <span>Choose Bixian</span> for WhatsApp Marketing?
                </h1>
                <p className='rowThreeContext'>
                When it comes to WhatsApp Marketing, Bixian stands out as a premier choice. Our expertise in leveraging this platform for effective marketing campaigns is unmatched. We offer tailored strategies, robust analytics, and seamless integration, ensuring maximum reach and engagement for your business.
                </p>
                <div className='rowThreeBoxes'>
                    {/* box 1 */}
                    <div className='box boxOne'>
                        <div className='context'>
                            <img loading="lazy" src={tailoredStrategies} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Tailored Strategies
                            </h2>
                            <p className='boxPara'>
                            Bixian crafts personalized WhatsApp Marketing strategies tailored to your business goals, audience, and industry, ensuring optimal results and ROI.
                            </p>
                        </div>
                    </div>
                    {/* box 2 */}
                    <div className='box boxTwo'>
                        <div className='context'>
                            <img loading="lazy" src={robustAnalytics} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Robust Analytics
                            </h2>
                            <p className='boxPara'>
                            We provide in-depth analytics and insights, allowing you to track the performance of your WhatsApp Marketing campaigns in real-time and make data-driven decisions.
                            </p>
                        </div>
                    </div>
                    {/* box 3 */}
                    <div className='box boxThree'>
                        <div className='context'>
                            <img loading="lazy" src={seamlessIntegration} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Seamless Integration
                            </h2>
                            <p className='boxPara'>
                            Bixian seamlessly integrates WhatsApp Marketing with your overall marketing strategy, ensuring consistency across all channels and maximizing impact.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

function WMR4(){
    return(
        <div className='wmr4'>
            <div className='rowFourContainer'>
                <div className='rowFourContext'>
                    <h1 className='rowFourHead'>Our Process</h1>
                    <p className='rowFourPara'>
                    Unlock the potential of WhatsApp Marketing with Bixian's refined approach. Our process is meticulously crafted for success, focusing on precision targeting, captivating content, and measurable outcomes, ensuring your campaigns achieve their full potential, driving engagement and conversions like never before.
                    </p>
                </div>
                <div className='rowFourBoxes'>
                    <div className='box boxOne'>
                            <img loading="lazy" src={precisionTargeting} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Precision Targeting</h2>
                        <p className='boxPara'>We identify and engage with your target audience through strategic segmentation and personalized messaging, maximizing the impact of your campaigns.</p>
                    </div>
                    <div className='box boxTwo'>
                            <img loading="lazy" src={captivatingContent} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Captivating Content</h2>
                        <p className='boxPara'>Our team crafts compelling messages and visuals tailored to resonate with your audience, sparking interest and driving action.</p>
                    </div>
                    <div className='box boxThree'>
                            <img loading="lazy" src={measurableOutcomes} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Measurable Outcomes</h2>
                        <p className='boxPara'>With robust analytics and tracking, we provide actionable insights into campaign performance, enabling data-driven optimizations for continuous improvement.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

function ContactSection(){
    return(
        <div className="contactSection">
                <div className="box">
                    <div className="context">
                        <h1>Wanna Discuss More About Our WhatsApp Marketing?</h1>
                        <p>Schedule a free consultation and esitmate with our expert.</p>
                    </div>
                    <div className="buttonHolder">
                        <Link to='/contact'><button>Get A Free Estimation</button></Link>
                    </div>
                </div>
            </div>
    )
}